var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100.176 100.178",
    style: {
      enableBackground: "new 0 0 100.176 100.178"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0000ee",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 1,
    d: "M87.682,20.058L72.771,7.595c-0.305-0.256-0.703-0.378-1.096-0.343c-0.396,0.036-0.763,0.227-1.018,0.532l-6.465,7.739 l-4.882-4.078c-0.639-0.532-1.582-0.445-2.113,0.19l-9.565,11.45c-0.255,0.305-0.378,0.699-0.343,1.096 c0.036,0.396,0.227,0.762,0.533,1.017l12.338,10.306L37.117,63.083l-12.34-10.311c-0.306-0.254-0.7-0.379-1.096-0.343 c-0.396,0.035-0.762,0.228-1.017,0.532l-9.566,11.449c-0.531,0.636-0.447,1.582,0.189,2.113l4.882,4.079L12.13,77.83 c-0.255,0.306-0.378,0.699-0.343,1.096c0.036,0.396,0.227,0.762,0.532,1.018l14.915,12.463c0.271,0.226,0.612,0.349,0.962,0.349 c0.044,0,0.089-0.002,0.134-0.006c0.396-0.035,0.762-0.228,1.017-0.532l6.039-7.227l4.927,4.117 c0.271,0.226,0.612,0.349,0.962,0.349c0.044,0,0.089-0.002,0.134-0.006c0.396-0.035,0.762-0.228,1.017-0.532l9.567-11.449 c0.531-0.636,0.446-1.582-0.189-2.113L39.419,65.007l23.043-27.579l12.389,10.349c0.271,0.226,0.611,0.349,0.962,0.349 c0.045,0,0.089-0.002,0.134-0.006c0.396-0.036,0.763-0.227,1.018-0.533l9.564-11.451c0.531-0.636,0.446-1.582-0.189-2.113 l-4.929-4.117l6.461-7.736C88.402,21.535,88.317,20.59,87.682,20.058z M28.006,89.141L15.394,78.602l5.077-6.075l12.612,10.538 L28.006,89.141z M41.085,85.841l-4.855-4.057c-0.023-0.022-0.041-0.047-0.066-0.067c-0.024-0.02-0.052-0.034-0.077-0.052 l-14.78-12.35c-0.02-0.019-0.036-0.041-0.057-0.059c-0.021-0.018-0.046-0.029-0.068-0.046l-4.82-4.027l7.643-9.146l24.724,20.658 L41.085,85.841z M75.624,44.513L50.896,23.857l7.642-9.148l24.728,20.655L75.624,44.513z M79.108,27.983L66.495,17.447l5.503-6.588 l12.609,10.54L79.108,27.983z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetal);
export default __webpack_public_path__ + "static/media/metal.c9b120b885c310c54f3a19c3299aa03b.svg";
export { ForwardRef as ReactComponent };